export const BASE_URL = "https://sparkademy.directus.app";

export const CDN_ASSETS_URL = "https://cms-assets.sparkademy.com";

export const generateImageUrl = (imageId: string) => {
  return `${CDN_ASSETS_URL}/${imageId}?access_token=6t8QsiptwYY9BiDhUYdq`;
};
